import React from "react";
import "./HeroSection.css";
import facebookIcon from "../assets/svg/fa-facebook.svg";
import instagramIcon from "../assets/svg/fa-instagram.svg";
import tiktokIcon from "../assets/svg/fa-tiktok.svg";
import youtubeIcon from "../assets/svg/fa-youtube.svg";
import heroImage from "./assets/hero.jpg";

function HeroSection({ title, text, customVisual, onVisualClick }) {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-text-main">
            <h1 className="hero-title title-sm">{title}</h1>
            <div className="hero-paragraph">{text}</div>
          </div>

          <div className="social-icons">
            <a
              href="https://www.facebook.com/beszeljegyesulet"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebookIcon} alt="Facebook" />
            </a>

            <a
              href="https://www.instagram.com/beszeljegyesulet"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagramIcon} alt="Instagram" />
            </a>

            <a
              href="https://www.tiktok.com/@beszeljegyesulet"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={tiktokIcon} alt="TikTok" />
            </a>

            <a
              href="https://www.youtube.com/@beszeljegyesulet"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={youtubeIcon} alt="YouTube" />
            </a>
          </div>
        </div>

        <div
          className={`hero-image-wrapper ${
            customVisual
              ? "hero-image-wrapper--custom"
              : "hero-image-wrapper--image"
          }`}
          onClick={onVisualClick || undefined}
          style={onVisualClick ? { cursor: "pointer" } : undefined}
        >
          {customVisual ?? (
            <img src={heroImage} alt="Hero" className="hero-image" />
          )}
        </div>
      </div>
    </section>
  );
}

export default HeroSection;